import { useContext } from "react"
import { EventSetupWizard, Page } from "@components"
import { ModalContext, UserContext } from "@context"
import { hasOrganiserRights } from "@helpers"
import { PencilSquareIcon } from "@heroicons/react/24/outline"
import { useSetActiveSidebarLink } from "@hooks"
import { Button } from "@heroui/react"

const NoEvents = () => {
  const { user } = useContext(UserContext)
  const { setModal } = useContext(ModalContext)
  const isOrganiser = hasOrganiserRights(user)

  useSetActiveSidebarLink("CREATE_EVENT")

  const handleCreateEvent = () => {
    setModal(prevState => ({ ...prevState, isOpen: true, title: "Event Setup Wizard", content: <EventSetupWizard previousLink="CREATE_EVENT" user={user} /> }))
  }

  return (
    <Page classNames="bg-content2">
      <div className="flex flex-col items-center justify-center min-h-screen -mt-16">
        {isOrganiser && (
          <div className="flex flex-col items-center max-w-md text-center">
            <PencilSquareIcon className="w-auto h-auto max-h-96 text-foreground-800" />
            <h1 className="mb-2 text-3xl font-bold text-foreground-700">Create your first event</h1>
            <p className="mb-6 text-lg leading-7">You currently have no events. Click the button below to create your first.</p>
            <Button className="font-semibold" radius="full" size="lg" color="secondary" onPress={() => handleCreateEvent()}>Create Event</Button>
          </div>
        )}

        {!isOrganiser && (
          <div className="flex flex-col items-center max-w-xl text-center">
            <PencilSquareIcon className="w-auto h-auto max-h-96 text-foreground-800" />
            <h1 className="mb-2 text-3xl font-bold text-foreground-700">You have no events</h1>
            <p className="text-lg leading-7">You currently have no events. Events will appear here once opened to staff by your administrator.</p>
          </div>
        )}
      </div>
    </Page>
  )
}

export default NoEvents